<style lang="scss">
.permission-camera {
  &__view {
    border-radius: 20px;
    background-color: #333;
  }
}
</style>

<template>
  <div class="fill-height pa-5 permission-camera">
    <div class="text-xs-center">
      <p class="mb-5 display-4 font-weight-regular">
        <span class="d-inline-block red--text text--lighten-2 --attention">
          {{ isPermission ? '踩踏板' : '允許' }}
        </span>
        {{ isPermission ? '截圖' : '使用攝影機' }}
      </p>

      <v-slide-x-transition group hide-on-leave>
        <video
          ref="video"
          key="video"
          height="360"
          width="480"
          autoplay
          class="permission-camera__view"
        />
        <canvas
          v-if="isPermission"
          ref="canvas"
          key="canvas"
          height="360"
          width="480"
          class="ml-4 permission-camera__view"
        />
      </v-slide-x-transition>
    </div>

    <faq-switch-drawer title="攝影機" :items="faqs" />
  </div>
</template>

<script>
import { throttle } from 'lodash'

import FaqSwitchDrawer from './faq-drawer'

const KEY_Z = 90
const BASE64_PREFFIX = 'data:image/png;base64,'

export default {
  name: 'PermissionCamera',
  components: {
    FaqSwitchDrawer,
  },
  data() {
    return {
      isPermission: false,
      device: '未取得授權',
      stream: null,
    }
  },
  computed: {
    faqs() {
      return [
        {
          id: 'camera-1',
          text: '瀏覽器網址列內最右側是否有出現攝影圖案 ',
          icons: ['videocam'],
        },
        {
          id: 'camera-2',
          text: `是否選擇正確的影像源，目前為: ${this.device}。`,
        },
        {
          id: 'camera-3',
          text: '確認 chrome://flags/#unsafely-treat-insecure-origin-as-secure 是否包含正確的服務路徑。',
          href: 'chrome://flags/#unsafely-treat-insecure-origin-as-secure',
        },
        {
          id: 'camera-4',
          text: '截圖測試，是否會截出 "非全黑" 或 "非全白" 的圖片, SDI轉接器的兩頭有可能 "鬆脫"，導致沒有影像來源。',
        },
        {
          id: 'camera-5',
          list: {
            title: '轉接器上的燈號，例如:',
            items: [
              '原剛 - 藍色正常, 紅色是訊號異常',
              '登昌恆黑盒子 - 綠燈是否有亮',
            ],
          },
        },
      ]
    },
  },
  mounted() {
    setTimeout(this.camera, 2000)
  },
  beforeDestroy() {
    removeEventListener('keydown', this.throttleKeydown)

    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop())
    }
  },
  methods: {
    camera() {
      navigator.mediaDevices
        .getUserMedia({
          audio: false,
          video: true,
        })
        .then(this.success)
        .catch(this.error)
    },
    success(stream) {
      this.stream = stream
      this.$refs.video.srcObject = stream
      this.device = stream.getTracks()[0].label

      setTimeout(() => {
        this.$emit('notify')
      }, 2000)
      setTimeout(() => {
        this.isPermission = true
        this.throttleKeydown = throttle(this.keydown, 500, { leading: true })
        addEventListener('keydown', this.throttleKeydown)
      }, 3000)
    },
    error(e) {
      console.warn('[ERROR] getUserMedia:', e.message, e.name)
      this.$emit('valid', { step: 2, valid: false })
    },
    keydown(evt) {
      if (evt.keyCode === KEY_Z) {
        if (this.$refs.video && this.$refs.canvas) {
          const { video, canvas } = this.$refs

          canvas
            .getContext('2d')
            .drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
          if (canvas.toDataURL().replace(BASE64_PREFFIX, '').length) {
            removeEventListener('keydown', this.throttleKeydown)

            setTimeout(() => {
              this.$emit('notify')
            }, 2000)
            setTimeout(() => {
              this.$emit('valid', { step: 2, valid: true })
            }, 4000)
          } else {
            this.$emit('valid', { step: 2, valid: false })
          }
        }
      }
    },
  },
}
</script>
